{
  "regenesis": 0,
  "qa": 0,
  "app": 0,
  "telcar": 1,
  "esipick": 2,
  "demo": 3,
  "dpp": 4,
  "alkaram": 5,
  "sapphire": 6,
  "cbl": 7,
  "rukh": 8
}
